import React, { useEffect, useState, useCallback, useRef } from 'react'
import AddIcon from '@mui/icons-material/Add';
import Slider from "react-slick";
import { useSelector, useDispatch } from 'react-redux';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import { setSaldoGraphData } from "./../features/saldoGraphDataSlice";

import { DateTime } from 'luxon';
import md5 from 'md5';
import { useNavigate } from 'react-router';


function BoxInfoHome() {
    const dispatch = useDispatch();

    const currentBalance = useSelector((user) => user?.user?.currentBalance);
    const currentBalanceEnrica = useSelector((user) => user?.user?.currentBalanceEnrica);
    const expiryBalanceEnrica = useSelector((user) => user?.user?.expiryBalanceEnrica)
    const token = useSelector((user) => user.user.info.token_value);
    const userToken = useSelector((user) => user.user.info.user_id);
    const customerId = useSelector((user) => user.user.info.customer_id);
    const podCode = useSelector((user) => user.user.info.pod_code);
    const offerta = useSelector((user) => user.user.offerta)
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const idGroup = useSelector((user) => user.user.idGruppo)
    const [balance1, setBalance1] = useState({ integer: "0", decimal: "00", isNegative: false });
    const [balance2, setBalance2] = useState({ integer: "0", decimal: "00", isNegative: false });
    const [balance3, setBalance3] = useState({ integer: "0", decimal: "00", isNegative: false });

    //const [dataBox, setDataBox] = useState()
    const saldoGraphData = useSelector((saldoGraphData) => saldoGraphData.saldoGraphData.saldoGraphData);
    const [index, setIndex] = useState(0);

    //uses as counter beacause I need that two functions must be finished to end loading
    const [loading, setLoading] = useState(0);

    const setBalances = useCallback((currentBalance, currentBalanceEnrica, expiryBalanceEnrica) => {
        setLoading(c => c + 1);
        let isNegative = currentBalance < 0;
        let res = getIntegerDecimalFromNumber(parseFloat(currentBalance).toFixed(2).replace(/\./g, ",").replace("-", ""));
        if (res[0] !== undefined && res[1] !== undefined) setBalance1({ integer: res[0], decimal: res[1], isNegative: isNegative });
        res = getIntegerDecimalFromNumber(parseFloat(currentBalanceEnrica).toFixed(2).replace(/\./g, ",").replace("-", ""));
        isNegative = currentBalanceEnrica < 0;
        if (res[0] !== undefined && res[1] !== undefined) setBalance2({ integer: res[0], decimal: res[1], isNegative: isNegative });
        res = getIntegerDecimalFromNumber(parseFloat(expiryBalanceEnrica).toFixed(2).replace(/\./g, ",").replace("-", ""));
        if (res[0] !== undefined && res[1] !== undefined) setBalance3({ integer: res[0], decimal: res[1], isNegative: false });
        setLoading(c => c - 1);
    }, []);

    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    const init = useCallback(async () => {
        setLoading(c => c + 1);
        
        const yearApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryRevo.php?` +
            `customer_id=${customerId}&user_id=${userToken}&token=${token}&pod_code=${podCode}&tkn_pvt=${tkn}`;
        const { data: { data: [previousMonthData] } } = await axios.get(yearApi);
        const currentMonthName = "Spesa di " + capitalize(DateTime.local().toFormat('MMMM'));

        const dateStart = DateTime.local().startOf('month').toISODate();
        const dateEnd = DateTime.local().endOf('month').toISODate();

        const url = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryMonthNew.php?` +
            `codice_pod=${podCode}&token=${token}&userToken=${userToken}&debug=1&date_start=${dateStart}&date_end=${dateEnd}`;

        const { data: { data: { consumptions: dataMonth } } } = await axios.get(url);
        const getNumber = dataMonth !== null ? dataMonth.map((r) => parseFloat(r.spesa_giorno)) : null;
        const currentMonthData = getNumber !== null ? getNumber.reduce((a, b) => a + b).toFixed(2) : null;
        let previousMonthName = "Spesa di " + capitalize(DateTime.fromISO(previousMonthData.data_competenza).toFormat("MMMM"));
        let data1 = previousMonthData.entry_amount;
        if (previousMounthNumber(DateTime.local().toFormat('M')) !==
            DateTime.fromISO(previousMonthData.data_competenza).toFormat("M")) {
            const previousMonthDate = DateTime.local().minus({ months: 1 });
            const dateStart = previousMonthDate.startOf('month').toISODate();
            const dateEnd = previousMonthDate.endOf('month').toISODate();
            const dataApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryMonthNew.php?` +
                `codice_pod=${podCode}&token=${token}&userToken=${userToken}&debug=1&date_start=${dateStart}&date_end=${dateEnd}`;
            const { data: { data: customPreviousData } } = await axios.get(dataApi);
            data1 = customPreviousData.consumptions.map((i) => i.spesa_giorno).reduce((a, b) => parseFloat(a) + parseFloat(b));
            previousMonthName = "Spesa di " + capitalize(previousMonthDate.toFormat("MMMM"));
        }
        dispatch(setSaldoGraphData(
            [{ name: previousMonthName, value: data1 },
            { name: currentMonthName, value: currentMonthData }]));
        setLoading(c => c - 1);
    }, [customerId, userToken, token, podCode, dispatch]);

    useEffect(() => {
        if (saldoGraphData === null || saldoGraphData === undefined) {
            init();
        }
    }, [init, saldoGraphData]);

    useEffect(() => {
        if (currentBalance !== null && currentBalanceEnrica !== null) {
            setBalances(currentBalance, currentBalanceEnrica, expiryBalanceEnrica);
        }
    }, [currentBalance, currentBalanceEnrica, expiryBalanceEnrica, setBalances]);

    const getIntegerDecimalFromNumber = (number) => {
        const type = typeof (number);
        let rawNumber;
        if (type === "number") {
            rawNumber = number.toString();
        } else if (type === "string") {
            rawNumber = number;
        } else {
            return false;
        }
        let indexOfComa = rawNumber.indexOf(',');
        let indexOfPoint = rawNumber.indexOf('.');

        const index = indexOfComa !== -1 ? indexOfComa : indexOfPoint !== -1 ? indexOfPoint : false;
        if (!index) {
            return false;
        }
        const integer = rawNumber.substring(0, index);
        const decimal = rawNumber.substring(index + 1, rawNumber.length + 1);
        return [integer, decimal];
    }

    const stopBody = () => {
        var body = document.body;

        body.classList.add("stop");
    }
    const scrollBody = () => {
        var body = document.body;

        body.classList.remove("stop");
    }

    const settingSlick = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        initialSlide: 0,
        adaptiveHeight: true
    };

    const beforeChange = useCallback((_, i) => setIndex(i), [setIndex]);

    const sliderRef = useRef();

    const previousMounthNumber = (x) => ((parseInt(x) + 10) % 12 + 1);
    const navigate = useNavigate();
    const getPiano = () => {
        switch (idGroup) {
            case 1:
                return 'Piano Ricaricabile';
            case 2:
                return 'Piano Relax';
            default:
                return 'Piano Tradizionale';
        }
    }
    return (
        <div className="box-info-home-container">
            <div className="box-info-wrapper top-wrapper">
                <div className="label">
                    <LocalActivityIcon className="label-icon" />
                    <p className="label-text">{getPiano()}</p>
                </div>
            </div>
            {loading > 0 ? <CircularProgress style={{ margin: 'auto', color: '#fff' }} /> : <>
                <div className="box-info-wrapper">
                    <CustomHorizontalBarChart
                        series={(saldoGraphData !== undefined && saldoGraphData !== null) ? saldoGraphData.map((r) => (

                            {
                                name: r.name,
                                data: r.value
                            }
                        )) : null}
                        colors={["#B9BABB", "#F39800"]} />
                </div>

                <div className="box-info-wrapper bottom-wrapper">
                <div className="actions">
                    <div className="quick-action-shadow">
                        <div className="quick-action" onClick={() => navigate('/enrica/ricarica')}>
                            <AddIcon />
                        </div>
                    </div>
                </div>
                <div className="action-label">

                    <svg width="27" height="10" viewBox="0 0 27 10" fill="none" xmlns="http://my.w3.org/2000/svg">
                        <path d="M1.0001 1.49298L11.3852 8.77615L26.4592 8.77617" stroke="#5AD8A6" strokeWidth="2" />
                    </svg>
                    Ricarica subito
                </div>
                    <div className="balance-view" onTouchStart={stopBody} onTouchEnd={scrollBody}>
                        <Slider {...settingSlick} beforeChange={beforeChange} ref={sliderRef}>
                            <div className="balance">
                                <p className={`balance-value ${balance1.isNegative ? `negative` : `positive`}`}>
                                    <span className="sign">{balance1.isNegative ? "-" : "+"}</span>{balance1.integer !== "" ? balance1.integer : "00"}
                                    <span className="balance-decimal">{balance1.decimal && balance1.decimal !== "" ? "," + balance1.decimal : ",00"}</span>
                                </p>
                                <p className="balance-label">Saldo reale (€)</p>
                            </div>
                            <div className="balance">
                                <p className={`balance-value ${balance2.isNegative ? `negative` : `positive`}`}>
                                    <span className="sign">{balance2.isNegative ? "-" : "+"}</span>{balance2.integer !== "" ? balance2.integer : "00"}
                                    <span className="balance-decimal">{balance2.decimal && balance2.decimal !== "" ? "," + balance2.decimal : ",00"}</span>
                                </p>
                                <p className="balance-label">Saldo oggi (€)</p>
                            </div>
                            <div className="balance">
                                <p className={`balance-value ${balance3.isNegative ? `negative` : `negative`}`}>
                                    <span className="sign">{balance3.isNegative ? "-" : "-"}</span>{balance3.integer !== "" ? balance3.integer : "00"}
                                    <span className="balance-decimal">{balance3.decimal && balance3.decimal !== "" ? "," + balance3.decimal : ",00"}</span>
                                </p>
                                <p className="balance-label">Saldo in scadenza (€)</p>
                            </div>
                        </Slider>
                        <div className='dots-container'>
                            <div className={`dot ${index === 0 ? 'active' : ''}`} onClick={() => sliderRef.current.slickGoTo(0)} />
                            <div className={`dot ${index === 1 ? 'active' : ''}`} onClick={() => sliderRef.current.slickGoTo(1)} />
                            <div className={`dot ${index === 2 ? 'active' : ''}`} onClick={() => sliderRef.current.slickGoTo(2)} />
                        </div>
                    </div>

                </div>
            </>}

        </div>
    )
}
/**
 * 
 * @param series
 * The format of series must be:
 * series=[
 *      {
 *          name: "series-name":String,
 *          data: "series-value":Number
 *      },
 * ]
 * @param colors
 * colors: ['color1', 'color2']
 */
const CustomHorizontalBarChart = ({ series, colors }) => {

    const maxWidth = 182;
    let max = 0;
    let maxIndex = 0;
    if (series !== null) {
        series.map(({ _, data }, index) => {
            if (data > max) {
                max = data;
                maxIndex = index;
            }
        });
    }


    const maxProportion = (index) => {
        if (index === maxIndex) {
            return maxWidth;
        }
        const value = series[index].data;
        const proportion = value / max;
        return Math.round(maxWidth * proportion)

    }

    const splitNumber = (number) => {
        const type = typeof (number);
        let rawNumber;
        if (type === "number") {
            rawNumber = number.toString();
        } else if (type === "string") {
            rawNumber = number;
        } else {
            return false;
        }
        let indexOfComa = rawNumber.indexOf(',');
        let indexOfPoint = rawNumber.indexOf('.');

        const index = indexOfComa !== -1 ? indexOfComa : indexOfPoint !== -1 ? indexOfPoint : false;
        if (!index) {
            return false;
        }
        const integer = rawNumber.substring(0, index);
        const decimal = rawNumber.substring(index + 1, rawNumber.length + 1);
        return [integer, decimal];
    }

    return (
        <div className="custom-bar-chart-container">
            <div className="start-bar" />
            <div className="bars-container">
                {series !== null ? series.map(({ name, data }, index) => (
                    <div className="bar-container" key={index}>
                        <div className="bar" style={{ width: maxProportion(index), backgroundColor: colors[index % colors.length] }} />
                        <div className="bar-text-container" style={{ color: index === series.length - 1 ? '#FFFFFF' : "#B2B3B4" }}>
                            <p className="bar-value" >{splitNumber(data)[0] || data}{data[1] ? `,` + splitNumber(data)[1].slice(0, 2) : null}<span className="bar-value-label">€</span></p>
                            <p className="bar-name">{name}</p>
                        </div>
                    </div>
                )) : null}
            </div>
        </div>
    );
}

export default BoxInfoHome
